import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import dayjs from 'dayjs';

const DownloadAttendanceReportPdf = (attendanceData, companyName, logo, setOpenBackdrop, dateRange) => {
    const dataList = Array.isArray(attendanceData) ? attendanceData : [];

    if (dataList.length === 0) {
        alert("No attendance data found to print!");
        return;
    }

    const doc = new jsPDF('l', 'mm', 'a4'); // Landscape layout
    if (typeof setOpenBackdrop === 'function') setOpenBackdrop(true);

    try {
        const pageWidth = doc.internal.pageSize.getWidth(); // A4 Landscape is ~297mm

        // --- 1. Logo & Company Name Setup ---
        if (logo) {
            doc.addImage(logo, 'PNG', 14, 10, 15, 15);
        }
        
        doc.setFontSize(18);
        doc.setTextColor(25, 118, 210); // Professional Blue
        doc.setFont("helvetica", "bold");
        doc.text(companyName || 'COMPANY NAME', logo ? 35 : 14, 19);
        
        // --- 2. Centered Main Header Title ---
        doc.setFontSize(14);
        doc.setTextColor(60, 60, 60);
        doc.setFont("helvetica", "bold");
        doc.text('ATTENDANCE SUMMARY REPORT', pageWidth / 2, 32, { align: 'center' });

        // --- 3. Dynamic Date Range Display ---
        const startDate = dateRange && dateRange[0] ? dayjs(dateRange[0]).format("DD-MM-YYYY") : "N/A";
        const endDate = dateRange && dateRange[1] ? dayjs(dateRange[1]).format("DD-MM-YYYY") : "N/A";
        
        doc.setFontSize(10);
        doc.setTextColor(100);
        doc.setFont("helvetica", "normal");
        doc.text(`Date Range: ${startDate} to ${endDate}`, pageWidth / 2, 38, { align: 'center' });

        // Top Decorative Section Border
        doc.setDrawColor(200);
        doc.line(14, 24, pageWidth - 14, 24);

        // --- 4. Table Setup (Removed Employee ID) ---
        const tableHeaders = [[
            'S.No', 
            'Employee Name', 
            'Email', 
            'Address', 
            'Total Days', 
            'Present', 
            'Absent',
            'Leave',
            'Holiday'
        ]];

        const tableData = dataList.map((item, idx) => [
            idx + 1,
            item.employee_name || 'N/A',
            item.email || '—',
            item.address || '—',
            item.total_days || 0,
            item.present || 0,
            item.absent || 0,
            item.leave || 0,
            item.holiday || 0
        ]);

        // --- 5. Generate Dynamic Table ---
        doc.autoTable({
            startY: 45, // Moved down to accommodate centered subtitles safely
            head: tableHeaders,
            body: tableData,
            theme: 'striped',
            headStyles: { 
                fillColor: [25, 118, 210], 
                textColor: [255, 255, 255],
                fontSize: 9.5,
                fontStyle: 'bold',
                halign: 'center'
            },
            styles: { 
                fontSize: 9, 
                cellPadding: 3 
            },
            columnStyles: {
                0: { cellWidth: 12, halign: 'center' },  // S.No
                1: { cellWidth: 45 },                    // Name
                2: { cellWidth: 50 },                    // Email
                3: { cellWidth: 70 },                    // Address
                4: { cellWidth: 22, halign: 'center' },  // Total Days
                5: { cellWidth: 18, halign: 'center' },  // Present
                6: { cellWidth: 18, halign: 'center' },  // Absent
                7: { cellWidth: 18, halign: 'center' },  // Leave
                8: { cellWidth: 18, halign: 'center' },  // Holiday
            },
            didDrawPage: (data) => {
                const totalPages = doc.internal.getNumberOfPages();
                doc.setFontSize(8);
                doc.setTextColor(150);
                doc.text("Page " + totalPages, pageWidth - 14, 202, { align: 'right' });
                doc.text("Generated on: " + dayjs().format("DD-MM-YYYY HH:mm:ss"), 14, 202);
            }
        });

        // --- 6. Save PDF ---
        const timestamp = new Date().getTime();
        doc.save(`${(companyName || 'Company').replace(/\s+/g, '_')}_Attendance_${timestamp}.pdf`);

    } catch (error) {
        console.error("PDF Generation Error:", error);
        alert("Something went wrong while generating the PDF");
    } finally {
        if (typeof setOpenBackdrop === 'function') setOpenBackdrop(false);
    }
};

export default DownloadAttendanceReportPdf;